import { render } from "./ViewStock.vue?vue&type=template&id=78e8a348&scoped=true&ts=true"
import script from "./ViewStock.vue?vue&type=script&lang=ts"
export * from "./ViewStock.vue?vue&type=script&lang=ts"

import "./ViewStock.vue?vue&type=style&index=0&id=78e8a348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e8a348"]])

export default __exports__